import React from 'react';

import { createIsolation } from 'jotai-scope';
import { atomWithStorage } from 'jotai/utils';

/**
 * AIMS 디버깅 atom.
 */
const devtoolsAtom = atomWithStorage<{
  delayAutoSaveMs?: number;
}>('aims.devtools', {});

const { Provider, useAtom, useAtomValue, useSetAtom } = createIsolation();

export const DevtoolsProvider: ReturnType<typeof createIsolation>['Provider'] = Provider;

/**
 * AIMS 디버깅 atom 훅.
 */
export const useDevtoolsAtom = () => {
  return useAtom(devtoolsAtom);
};

/**
 * AIMS 디버깅 atom 훅.
 */
export const useDevtoolsAtomValue = () => {
  return useAtomValue(devtoolsAtom);
};

/**
 * AIMS 디버깅 atom ref 훅.
 */
export const useDevtoolsAtomRef = () => {
  const value = useAtomValue(devtoolsAtom);
  const ref = React.useRef(value);
  ref.current = value;
  return ref;
};

/**
 * AIMS 디버깅 atom 훅.
 */
export const useDevtoolsSetAtom = () => {
  return useSetAtom(devtoolsAtom);
};
